import React, { Component } from 'react';
import { PrimaryButton, AppHeader } from '../base-components';
import { fonts } from '../styleguide';
import { Link } from 'react-router';
import { strings as _strings } from '../lib';
const strings = _strings.auth;

const styles = {
    container: {
    position: 'absolute',
    display: 'flex',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: 'column'
  },
  innerContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  inputContainer: {
    margin: 10
  },
  btn: {
    marginTop: 10
  },
  link: {
    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 16,
    color: 'black',
    textDecoration: 'none'
  }
};

// TODO: merge with login?
export default class Signup extends Component {

  static propTypes = {
    account: React.PropTypes.any.isRequired,
    onUpdateAccount: React.PropTypes.func.isRequired,
    onSignup: React.PropTypes.func.isRequired
  };
  
  render() {
    const { account, onUpdateAccount, onSignup } = this.props;
    return (
      <div style={styles.container}>
        <AppHeader renderRightItem={() => <Link style={styles.link} to="/login">{strings.loginLink}</Link>} />
        <div style={styles.innerContainer}>
          <p style={fonts.mainTitle}>{strings.signupLabel}</p>
          <div style={styles.inputContainer}>
          {this.renderTextInput('text',
                                account.get('emailAddress'),
                                (event) => onUpdateAccount(account.merge({ emailAddress: event.target.value })),
                                strings.emailPlaceholder)}
          {this.renderTextInput('password',
                                account.get('password'),
                                (event) => onUpdateAccount(account.merge({ password: event.target.value })),
                                strings.passwordPlaceholder)}
          {this.renderTextInput('text',
                                account.get('accessCode'),
                                (event) => onUpdateAccount(account.merge({ accessCode: event.target.value })),
                                strings.accessCodePlaceholder)}
          </div>
          <PrimaryButton onPress={onSignup.bind(null, account)}
                         title={strings.signupLabel}
                         style={styles.btn}/>
        </div>
      </div>
    );
  }

  renderTextInput(type, val, onChange, placeholder) {
    // TODO: use own input styles or make into reusable component
    return (
      <div className="add-patient-input-container">
        <input type={type}
               className="add-patient-input"
               placeholder={placeholder}
               value={val}
               onChange={onChange} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/signup.js